import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SOCKET_SERVER_URL_API = process.env.REACT_APP_SOCKET_SERVER_URL_API;

function DeviceLookup() {
    const navigate = useNavigate();
    const { deviceId } = useParams();
    const [deviceData, setDeviceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deviceList, setDeviceList] = useState([]);

    useEffect(() => {
        const fetchDevices = async () => {
            try {
                const response = await axios.get(`${SOCKET_SERVER_URL_API}/dcore-dropdown`);
                setDeviceList(response.data.dCore);
            } catch (error) {
                console.error('Error fetching device list:', error);
            }
        };
        fetchDevices();
    }, []);

    useEffect(() => {
        if (!deviceId) return;

        const fetchDeviceDetails = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${SOCKET_SERVER_URL_API}/device/${deviceId}`);
                setDeviceData(response.data);
            } catch (error) {
                console.error('Error fetching device data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchDeviceDetails();
    }, [deviceId]);

    const handleChange = (e) => {
        const selectedId = e.target.value;
        navigate(`/device/${selectedId}`);
    };

    return (
        <div style={{
            padding: '3rem',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f8f9fa',
            minHeight: '100vh'
        }}>
            <div style={{
                maxWidth: '700px',
                margin: '0 auto',
                background: '#ffffff',
                padding: '2rem',
                borderRadius: '16px',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
            }}>
                <h2 style={{ fontSize: '1.8rem', color: '#333', marginBottom: '1.5rem' }}>
                    🔍 Device Message Lookup
                </h2>

                <label htmlFor="deviceDropdown" style={{ fontWeight: 'bold', color: '#555' }}>
                    Select Device:
                </label>
                <select
                    id="deviceDropdown"
                    value={deviceId || ''}
                    onChange={handleChange}
                    style={{
                        marginLeft: '1rem',
                        padding: '0.6rem 1rem',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        backgroundColor: '#f1f1f1',
                        cursor: 'pointer'
                    }}
                >
                    <option value="">-- Choose dCore --</option>
                    {deviceList.map((dcore, index) => (
                        <option key={index} value={dcore}>
                            {dcore}
                        </option>
                    ))}
                </select>

                {loading && (
                    <p style={{ marginTop: '2rem', color: '#777' }}>Loading device data...</p>
                )}

                {!loading && deviceData && (
                    <div style={{
                        marginTop: '2rem',
                        padding: '1.5rem',
                        borderRadius: '12px',
                        backgroundColor: '#eaf6f6',
                        border: '1px solid #bde0fe'
                    }}>
                        <h3 style={{ color: '#0077b6', marginBottom: '1rem' }}>📡 Device Info</h3>
                        <p><strong>dCore:</strong> {deviceData.dCore}</p>
                        <br></br>
                        <p><strong>📢 Message:</strong> <span style={{ fontWeight: 'bold', color: '#495057' }}>{deviceData.eVoiceMessage}</span></p>
                        <br></br>
                        <p><strong>🕒 Timestamp:</strong> {new Date(deviceData.timestamp).toLocaleString()}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DeviceLookup;
